import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import {
  DualDropDownWithSeachBar,
  Pagination,
  MetaDecorator,
} from 'src/views/components'
import { ContractsList } from './ContractsList'
import { accountsContainer } from 'src/models'
import { IS_BROWSER } from 'src/utils'
import { getFilterParams, constructQueryParam } from 'src/deps'
import { renderUserFilterInput } from './formInput'

@observer
class Contracts extends React.Component {
  @observable activePage = 1
  @observable searchStatus = 'All'
  @observable searchContract = ''
  handleChangeData = value => {
    this.searchContract = value
  }
  fetchContractList = async filterParams => {
    if (IS_BROWSER) {
      const queryParams = getFilterParams(location)
      const params = {
        page: queryParams.page || 1,
        ...filterParams,
      }
      this.activePage = parseInt(params.page)
      await accountsContainer.getContracts(params)
    }
  }
  componentDidMount() {
    this.fetchContractList(this.props)
  }

  handlePagination = async pageNumber => {
    this.activePage = pageNumber
    this.searchStatus = 'All'
    this.searchContract = ''
    const queryParams = getFilterParams(location)
    queryParams.page = pageNumber
    constructQueryParam(this.props, queryParams)
    this.fetchContractList(this.props)
  }
  handleSearchAndFilter = filterData => {
    if (this.activePage !== 1) {
      const queryParams = this.props?.location?.queryParams || {}
      delete queryParams.page
      constructQueryParam(this.props, queryParams)
      this.activePage = 1
    }
    const { currentlySelectedType, status, searchContract } = filterData
    const params = {}

    if (currentlySelectedType === 'searchContract') {
      this.searchStatus = 'All'
      params.searchContract = searchContract
    } else {
      this.searchContract = ''
      this.searchStatus = status !== '' && status !== undefined ? status : 'All'
      params.status = this.searchStatus !== 'All' ? this.searchStatus : ''
    }
    this.fetchContractList(params)
  }
  render() {
    const contractTitle = i18nTranslate('contract.title', 'Contract')
    const defaultSearchAndFilterValue = {
      defaultSearchStatus: this.searchStatus,
      defaultSearchContract: this.searchContract,
    }
    const formInputRender = renderUserFilterInput(defaultSearchAndFilterValue)
    const pageableInfo =
      accountsContainer?.contractsResponse?.pageableInfo || {}

    const { totalCount = 0, size = 0 } = pageableInfo

    const myAccountContractsTitle = i18nTranslate(
      'myAccountContracts.title',
      'Contracts | Nu Skin'
    )

    return (
      <>
        <MetaDecorator
          title={myAccountContractsTitle}
          imageUrl=""
          imageAlt=""
          description="Contracts Page"
          location={this.props}
        />
        <DualDropDownWithSeachBar
          filterInput={formInputRender}
          title={contractTitle}
          handleChangeData={this.handleChangeData}
          onSubmit={this.handleSearchAndFilter}
          searchBarClassName={'contract-search-bar'}
        />
        <ContractsList />
        {totalCount > size && (
          <Pagination
            handlePagination={this.handlePagination}
            totalPages={Math.ceil(totalCount / size)}
            active={this.activePage}
          />
        )}
      </>
    )
  }
}

export { Contracts }

// export default Contracts
export default Contracts
